import { createSlice } from "@reduxjs/toolkit";
import storageSession from "redux-persist/es/storage/session";
import { persistReducer } from "redux-persist";
import autoMergeLevel2 from "redux-persist/es/stateReconciler/autoMergeLevel2";
import { Business } from "../services/MyBizShell/mybizShellAPI.types";

type businessType = {
  businessSelectorData: Business[];
  navigatedByBusinessChange: boolean;
};

const initialStateBusinessSelector: businessType = {
  businessSelectorData: [],
  navigatedByBusinessChange: false,
};

const { actions, reducer } = createSlice({
  name: "businessSelectorData",
  initialState: initialStateBusinessSelector,
  reducers: {
    setBusinessSelectorData: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        businessSelectorData: [...payload],
      };
    },
    setNavigatedByBusiness: (state, action) => {
      return {
        ...state,
        navigatedByBusinessChange: action.payload,
      };
    },
  },
});

export const { setBusinessSelectorData, setNavigatedByBusiness } = actions;

const persistConfig = {
  key: "businessSelectorData",
  storage: storageSession,
  stateReconciler: autoMergeLevel2,
};

export default persistReducer<businessType>(persistConfig, reducer);
